<template>
  <div>
    <!-- ========== 设备分配 start ========== -->
    <el-dialog
      top="3vh"
      width="460px"
      center
      :close-on-click-modal="false"
      :title="`${
        CloudyDeviceObj.data
          ? CloudyDeviceObj.data.bankName +
            '「' +
            CloudyDeviceObj.data.bankCardNumber.match(/.{1,4}/g).join(' ')
          : ''
      }」设备分配`"
      :visible="CloudyDeviceObj.visible"
      @close="HandleCancel()"
    >
      <el-row>
        <el-form label-width="80px">
          <el-form-item
            label="目前设备"
            v-if="
              CloudyDeviceObj.data &&
              CloudyDeviceObj.data.cloudPhoneDeviceNo &&
              CloudyDeviceObj.data.cloudPhoneDeviceName
            "
            >{{ CloudyDeviceObj.data.cloudPhoneDeviceName }} -
            {{ CloudyDeviceObj.data.cloudPhoneDeviceNo
            }}<el-button
              style="margin-left: 10px"
              size="mini"
              type="danger"
              @click="HandleDeleteCloudPhone()"
              >取消分配
            </el-button>
          </el-form-item>
          <el-form-item label="平台">
            <el-select
              @change="HandleGetPlatform()"
              style="width: 320px"
              v-model="platform"
            >
              <el-option
                v-for="option in platformOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备">
            <el-select
              @change="HandleCheckExistBank()"
              style="width: 320px"
              v-model="cloudPhoneId"
              filterable
            >
              <el-option
                v-for="option in cloudPhoneOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
                <el-popover
                  v-if="option.usedBankDescription"
                  placement="right-start"
                  width="200"
                  trigger="hover"
                >
                  <div
                    v-for="item in option.usedBankDescription.split(',')"
                    :key="item"
                  >
                    {{ item }}
                  </div>
                  <div slot="reference">
                    {{ option.label }}
                  </div>
                </el-popover>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="HandleCancel()">取消</el-button>
        <el-button @click="setCloudyDevice()" type="success"> 保存 </el-button>
      </span>
    </el-dialog>
    <!-- ========== 设备分配 end ========== -->

    <!-- ========== 已分配银行详情 start ========== -->
    <el-dialog
      top="3vh"
      width="550px"
      center
      :visible="bankDetailDialog"
      @close="HandleBankDetailCancel()"
    >
      <div style="color: #ff0000; font-weight: 500; margin-bottom: 20px">
        提醒您：该设备已经分配过
        {{ bankDetailObj.bankName }} ({{ bankDetailObj.bankCode }}) 了，请确认！
      </div>
      <el-table
        border
        :data="bankDetailObj.accountList"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column label="帐户名">
          <template slot-scope="scopes">{{ scopes.row.account }}</template>
        </el-table-column>
        <el-table-column label="用户名">
          <template slot-scope="scopes">{{ scopes.row.username }}</template>
        </el-table-column>
      </el-table>
      <div style="text-align: center; margin-top: 20px">
        <el-button @click="HandleBankDetailCancel()" size="small"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <!-- ========== 已分配银行详情 end ========== -->
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { assignCloudPhone, unassignCloudPhone } from "@/api/account";
import { allCloudPhone } from "@/api/device";

export default {
  mixins: [mainCommon],
  props: ["CloudyDeviceObj"],
  data() {
    return {
      bankDetailDialog: false, // 银行详情弹窗
      bankDetailObj: {}, // 银行详情
      platform: "", // 平台
      cloudPhoneId: null, // 设备id
      cloudPhoneOptions: [], // 设备选项
      platformOptions: varCommon.platformOptions, // 平台选项
    };
  },
  watch: {
    CloudyDeviceObj(row) {
      if (row.visible) {
        this.getAllCloudPhone();
      }
    },
  },
  methods: {
    // 关闭银行详情弹窗
    HandleBankDetailCancel() {
      this.bankDetailDialog = false;
      this.bankDetailObj = {};
    },
    // 找到是否该设备已经分配到同一家银行
    HandleCheckExistBank() {
      // 找出该选项是否有匹配到银行列表
      let findDevice = this.cloudPhoneOptions.find((res) => {
        return res.value === this.cloudPhoneId;
      });
      // 对象银行是否有在银行列表其中
      let findBankObj = findDevice.usedBankList.find((res) => {
        return this.CloudyDeviceObj.data.bankCode === res.bankCode;
      });
      // 如果有则开启银行详情弹窗且带上银行列表信息供展示
      if (findBankObj) {
        this.bankDetailDialog = true;
        this.bankDetailObj = findBankObj;
      }
    },
    HandleGetPlatform() {
      // 清空 options 并重新请求接口
      this.cloudPhoneId = null;
      this.cloudPhoneOptions = [];
      this.getAllCloudPhone();
    },
    // 取消银行卡的设备
    HandleDeleteCloudPhone() {
      this.$confirm(
        "确定要取消设备「 " +
          this.CloudyDeviceObj.data.cloudPhoneDeviceNo +
          "」吗？",
        varCommon.message.warning,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "warning",
        }
      )
        .then(() => {
          unassignCloudPhone(this.CloudyDeviceObj.data.id).then((res) => {
            this.$notify.success(res.message);
            this.$emit("HandleGetList");
            this.HandleCancel();
          });
        })
        .catch(() => {});
    },
    // 取得设备选项
    getAllCloudPhone() {
      allCloudPhone({ platform: this.platform }).then((res) => {
        this.cloudPhoneOptions = res.data.map((item) => {
          let usedBankCardNum = "";
          if (item.usedBankCardNum) {
            usedBankCardNum = "(已分配" + item.usedBankCardNum + ")";
          } else {
            usedBankCardNum = "(空闲)";
          }
          return {
            label: `${item.platform} - ${item.deviceName} - ${item.deviceNo} ${usedBankCardNum}`,
            value: item.id,
            usedBankDescription: item.usedBankDescription,
            usedBankList: item.usedBankList,
          };
        });
      });
    },
    // 替银行卡分配设备
    setCloudyDevice() {
      assignCloudPhone({
        accId: this.CloudyDeviceObj.data.id,
        cloudPhoneId: this.cloudPhoneId,
      }).then((res) => {
        this.$notify.success(res.message);
        this.$emit("HandleGetList");
        this.HandleCancel();
      });
    },
    // 关闭设备分配弹窗
    HandleCancel() {
      this.platform = "";
      this.cloudPhoneId = null;
      this.cloudPhoneOptions = [];
      this.$emit("update:cloudy-device-obj", {});
    },
  },
};
</script>

<style scoped>
/deep/ .el-table td,
.el-table th {
  padding: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/account/bank/CloudyDeviceDialog.vue